
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { UserLevel } from '@/types/badge';

interface LevelDisplayProps {
  currentLevel: UserLevel;
  nextLevel: UserLevel | null;
  progress: number;
  points: number;
}

const LevelDisplay = ({ currentLevel, nextLevel, progress, points }: LevelDisplayProps) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-bold text-lg">會員等級</h3>
          <div className="flex items-center space-x-2">
            <span className={`px-3 py-1 rounded-full text-white text-sm font-medium ${currentLevel.color}`}>
              Lv.{currentLevel.level}
            </span>
            <span className="font-medium">{currentLevel.name}</span>
          </div>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-orange-600">{points}</div>
          <div className="text-sm text-gray-500">總積分</div>
        </div>
      </div>

      {nextLevel && (
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span>距離下一等級</span>
            <span className="font-medium">{nextLevel.name}</span>
          </div>
          <Progress value={progress} className="h-2" />
          <div className="flex justify-between text-xs text-gray-500">
            <span>{currentLevel.minPoints} 積分</span>
            <span>{progress}%</span>
            <span>{nextLevel.minPoints} 積分</span>
          </div>
        </div>
      )}

      <div className="mt-4">
        <h4 className="font-medium text-sm mb-2">等級權益</h4>
        <ul className="text-sm text-gray-600 space-y-1">
          {currentLevel.benefits.map((benefit, index) => (
            <li key={index} className="flex items-center">
              <span className="text-green-500 mr-2">✓</span>
              {benefit}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LevelDisplay;
